<template>
  <div>
    <card>
        <b-tab title="Tab 3">
            <b-card-text>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>DVR Documento di valutazione dei rischi<br>(D.lgs. 81/08)</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.dvr_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="dvr_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.dvr_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.dvr_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>L’autocertificazione vale fino a giugno 2013.</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>POS (D.lgs. 81/08, titolo IV): solo verifica del modello utilizzato</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.pos_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="pos_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.pos_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.pos_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>DUVRI (D.lgs. 81/08, titolo IV): (lavori eseguiti in azienda da ditte esterne)</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.duvri_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="duvri_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.duvri_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.duvri_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>

                <h3>Documenti id valutazione dei <b>rischi specifici</b> (possono essere contenuti o allegati al DVR, POS)</h3>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Chimico</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.chimico_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="chimico_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.chimico_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.chimico_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Aggiornamento periodico</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Stress lavoro correlato</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.stress_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="stress_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.stress_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.stress_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Rischio basso: agg. 2 anni<br>Rischio medio: agg. 1 anni</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Incendio</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.incendio_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="incendio_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.incendio_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.incendio_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Rischio basso: agg. 2 anni<br>Rischio medio: agg. 1 anni</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: ATEX (centrale termica, forni, ricarica batteria carrelli, depositi infiammabili)</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.atex_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="atex_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.atex_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.atex_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Rischio basso: agg. 2 anni<br>Rischio medio: agg. 1 anni</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Rumore</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.rumore_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="rumore_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.rumore_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.rumore_data_redazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Vibrazioni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.vibrazione_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="vibrazione_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.vibrazione_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.vibrazione_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Videoterminale</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.videoterminale_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="videoterminale_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.videoterminale_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.videoterminale_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche delle postazioni</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Amianto</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.amianto_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="amianto_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.amianto_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.amianto_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche o prima di demolizioni</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Biologico (es. laboratorio di analisi, rifiuti, az. Sanitarie)</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.biologico_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="biologico_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.biologico_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.biologico_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Cancerogeno/mutageni  (es. polveri di legno, benzina)</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.cancerogeno_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="cancerogeno_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.cancerogeno_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.cancerogeno_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche o almeno ogni 3 anni.</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Campi elettromagnetici</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.campi_el_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="campi_el_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.campi_el_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.campi_el_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Movimentazione carichi sollevamento e trasporto, spinta e traino, movimenti ripetuti</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.movimentazione_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="movimentazione_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.movimentazione_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.movimentazione_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Radiazioni ottiche</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.radiazioni_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="radiazioni_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.radiazioni_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.radiazioni_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Note: Agg. a seguito di modifiche</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Lavoratrici in gravidanza, differenza di genere, differenza di provenienza</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.lavoratrici_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="lavoratrici_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.lavoratrici_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.lavoratrici_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Legionella</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.legionella_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="legionella_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.legionella_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.legionella_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Microclima</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.microclima_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="microclima_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.microclima_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.microclima_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-md-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: Radiazioni solari</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.radiazioni_solari_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="radiazioni_solari_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.radiazioni_solari_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.radiazioni_solari_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-2">
                        <label>Tipologia del rischio: COVID-19</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.covid_evidenza"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="covid_data_redazione">Data redazione</label>
                        <input type="date" class="form-control" v-model="principaliDocumenti.covid_data_redazione">
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Predisporre</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="principaliDocumenti.covid_predisporre"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
            </b-card-text>
        </b-tab>
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
        
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';

export default {
    components: {
        Card
    },

    data() {
        return {
            principaliDocumenti: {},
            
            idCliente: null,
            idSoggetto: null,
        }
    },

    props: {
        principaliDocumentiValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addprincipaliDocumentiValori() {
            this.principaliDocumenti = Object.assign({}, this.principaliDocumentiValori);
        },

        // checkData: function() {
            // if () {
            //     alert("Compilare tutti i dati!");
            //     return false;
            // } else {
            //     return true;
            // }
        // },


        // salvaValoriDati: async function() {
        //     let errore = 0;
        //     let dati = [];
        //     dati.push({ 
        //        });
        //     let datiJSON=JSON.stringify(dati[0]);
        //     let salvaValori = [];
            // await AntiriciclaggioServices.updateSoggetto(datiJSON, this.idCliente, this.idSoggetto) 
            // .then(response => { salvaValori= response.data})
            // .catch( function (error) {
            //     if(error.response.status == 401){
            //     errore = error.response.status;
            //     }
            // });
            // if (errore == 401) {
            //     let value = await Services.refreshTokenFunction();
            //     if (value) { await this.salvaValoriDati(); }
            // }
        // },

        // main: async function() {
        //     this.idCliente = this.$route.query.idCliente;
            
        // },
    },
    created() {
        this.addprincipaliDocumentiValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
